import React from 'react';
import { motion } from 'framer-motion';
import { Gift, Check } from 'lucide-react';
const bonuses = [{
  num: '01',
  title: 'KIT PROFESIONAL PPI',
  items: ['Cómo construir un PPI paso a paso', 'Modelos listos', 'Estrategias inclusivas', 'Casos reales', 'Recursos editables'],
  insight: 'Ideal para trabajar inclusión educativa con más claridad.',
  img: 'https://cdn.magicpatterns.com/uploads/7oHZsFiaaPtj6syUjb7rDT/1.png'
}, {
  num: '02',
  title: 'ACTIVIDADES PARA LA PRÁCTICA PSICOPEDAGÓGICA',
  items: ['Habilidades matemáticas', 'Lectoescritura', 'Mix actividades', 'Pausa activa', 'Pictogramas y colorear', 'Juegos pedagógicos inclusión'],
  insight: 'Más recursos prácticos para tus sesiones.',
  img: 'https://cdn.magicpatterns.com/uploads/h1bdp7Ao5jRLqcRKtKZCVA/2.png'
}, {
  num: '03',
  title: 'PLANILLAS ÚTILES PARA PSICOPE',
  items: ['Anamnesis', 'Observación', 'Seguimiento', 'Objetivos', 'Devoluciones'],
  insight: 'Ahorrá tiempo y organizá mejor tu práctica.',
  img: 'https://cdn.magicpatterns.com/uploads/1faVRZEZKZmyrGv1rea92b/3.png'
}, {
  num: '04',
  title: 'FRASES PROFESIONALES PARA CLÍNICA Y DEVOLUCIONES',
  items: ['Entrevistas con familias', 'Devoluciones', 'Reuniones', 'Límites profesionales', 'Comunicación clara'],
  insight: 'Menos inseguridad al comunicarte profesionalmente.',
  img: 'https://cdn.magicpatterns.com/uploads/rWjaAbem2668GvWxfLtHw6/4.png'
}, {
  num: '05',
  title: 'AGENDA PSICO',
  items: ['Organización semanal', 'Seguimiento de pacientes', 'Objetivos', 'Notas clínicas', 'Organización profesional'],
  insight: 'Más orden y menos desborde mental.',
  img: 'https://cdn.magicpatterns.com/uploads/kQAoWzMBBRWgEsqqfGBKS2/5.png'
}];
const bonusPremium = [{
  title: 'MEGAPACK INCLUSIÓN EDUCATIVA',
  subtitle: 'Más de 600 actividades adaptadas listas para usar.',
  items: ['Material inclusivo', 'Recursos visuales', 'Actividades accesibles', 'Listo para imprimir'],
  img: 'https://cdn.magicpatterns.com/uploads/kyLZfwjTU8jkHJ5P9BFdeA/bonus_premium_1.png',
  price: '$19.990',
  emoji: '🌈'
}, {
  title: 'PSICOPE EN CASA',
  subtitle: 'Ideal para complementar el trabajo clínico.',
  items: ['Actividades para familias', 'Acompañamiento en casa', 'Material práctico y visual'],
  img: 'https://cdn.magicpatterns.com/uploads/2Xn3DCcbd1nbZG1ESCojD6/bonus_premium_2.png',
  price: '$19.990',
  emoji: '🏠'
}];
export function BonusSection() {
  return <section className="py-12 bg-gradient-to-b from-pink-50/40 to-rose-50/40" data-id="element-34">
      <div className="container mx-auto px-4 max-w-6xl" data-id="element-35">
        <div className="text-center mb-8" data-id="element-36">
          <span className="inline-flex items-center gap-2 bg-amber-100 text-amber-800 px-4 py-1.5 rounded-full font-bold text-xs tracking-widest uppercase mb-4" data-id="element-37">
            <Gift className="w-4 h-4" data-id="element-38" /> Gratis por el día de hoy
          </span>
          <h2 className="font-serif text-3xl md:text-4xl font-bold text-navy-900 uppercase tracking-tight" data-id="element-39">
            Además recibís estos bonus
          </h2>
        </div>

        {/* Bonus 1-5 with images */}
        <div className="grid sm:grid-cols-2 lg:grid-cols-3 xl:grid-cols-5 gap-5 mb-10" data-id="element-40">
          {bonuses.map((b, i) => <motion.div key={i} initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          delay: i * 0.06
        }} className="bg-white rounded-3xl p-5 shadow-sm border border-slate-100 flex flex-col hover:shadow-md transition-shadow" data-id="element-41">
              <div className="relative mb-5 h-44 flex items-center justify-center" data-id="element-42">
                <div className="absolute inset-0 bg-gradient-to-tr from-pink-50 to-rose-50/40 rounded-2xl -z-10" data-id="element-43" />
                <img src={b.img} alt={b.title} className="max-h-44 w-auto drop-shadow-xl" data-id="element-44" />
              </div>
              <span className="text-pink-600 font-bold text-xs uppercase tracking-widest mb-2" data-id="element-45">
                🎁 Bonus {b.num}
              </span>
              <h3 className="font-bold text-navy-900 text-sm mb-3 leading-tight uppercase tracking-tight" data-id="element-46">
                {b.title}
              </h3>
              <ul className="space-y-1.5 mb-4 flex-grow" data-id="element-47">
                {b.items.map((it, j) => <li key={j} className="flex items-start gap-2 text-xs" data-id="element-48">
                    <Check className="w-3.5 h-3.5 text-green-500 shrink-0 mt-0.5" data-id="element-49" />
                    <span className="text-slate-600" data-id="element-50">{it}</span>
                  </li>)}
              </ul>
              <p className="text-xs font-semibold text-pink-700 bg-pink-50 rounded-lg px-3 py-2" data-id="element-51">
                💡 {b.insight}
              </p>
            </motion.div>)}
        </div>

        {/* BONUS PREMIUM */}
        <div className="text-center mb-6" data-id="element-52">
          <span className="inline-flex items-center gap-2 bg-gradient-to-r from-pink-500 to-rose-500 text-white px-5 py-2 rounded-full font-bold text-xs tracking-widest uppercase shadow-md" data-id="element-53">
            ⭐ Bonus Premium
          </span>
        </div>

        <div className="grid md:grid-cols-2 gap-6 max-w-5xl mx-auto" data-id="element-54">
          {bonusPremium.map((b, i) => <motion.div key={i} initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          delay: i * 0.1
        }} className="bg-white rounded-3xl p-6 md:p-8 border-2 border-pink-200 shadow-lg relative overflow-hidden" data-id="element-55">
              <div className="absolute -top-8 -right-8 w-32 h-32 bg-pink-100 rounded-full opacity-50 blur-2xl" data-id="element-56" />
              <div className="relative grid grid-cols-[auto,1fr] gap-5 items-start" data-id="element-57">
                <div className="w-28 h-36 sm:w-32 sm:h-40 flex items-center justify-center" data-id="element-58">
                  <img src={b.img} alt={b.title} className="max-h-full w-auto drop-shadow-xl" data-id="element-59" />
                </div>
                <div className="flex flex-col" data-id="element-60">
                  <span className="text-pink-600 font-bold text-xs uppercase tracking-widest mb-1" data-id="element-61">
                    {b.emoji} Bonus Premium
                  </span>
                  <h3 className="font-bold text-navy-900 text-lg uppercase tracking-tight mb-2 leading-tight" data-id="element-62">
                    {b.title}
                  </h3>
                  <p className="text-slate-700 font-medium mb-3 text-sm" data-id="element-63">
                    {b.subtitle}
                  </p>
                  <div className="flex flex-wrap gap-1.5 mb-4" data-id="element-64">
                    {b.items.map((it, j) => <span key={j} className="bg-pink-50 text-pink-700 text-xs font-medium px-2.5 py-1 rounded-full border border-pink-100" data-id="element-65">
                        ✔ {it}
                      </span>)}
                  </div>
                  <div className="flex items-baseline gap-2 mt-auto" data-id="element-66">
                    <span className="text-xs text-slate-500 font-semibold uppercase tracking-wider" data-id="element-67">
                      Valor:
                    </span>
                    <span className="text-xl font-bold text-pink-600" data-id="element-68">
                      ARS {b.price}
                    </span>
                  </div>
                </div>
              </div>
            </motion.div>)}
        </div>
      </div>
    </section>;
}